import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import FormBody from '_components/formBody'

import styles from './styles.css'

const NOTE_STATUS = {
  1: 'Unread',
  2: 'Read',
  3: 'Resolved',
  4: 'Archived',
}

const Divider = () => (
  <div style={{ width: '100%', margin: '5px 0', border: '1px solid rgba(255,255,255,0.5)' }} />
)

export default class NoteDetails extends Component {
  static propTypes = {
    noteId: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    urgencyType: PropTypes.string.isRequired,
    preferredResponse: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    sentDate: PropTypes.string.isRequired,
    fromUser: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onResolve: PropTypes.func.isRequired,
    onReopen: PropTypes.func.isRequired,
    onOpened: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  state = {
    showMoreInfo: false,
  }

  componentWillMount() {
    const {
      onOpened,
      noteId,
      subject,
      urgencyType,
      preferredResponse,
      message,
      status,
    } = this.props
    const payload = { noteId, subject, urgencyType, preferredResponse, message, noteStatus: 2 }

    if (status === 1) onOpened(payload)
  }

  onToggleShowMore = () => this.setState({ showMoreInfo: !this.state.showMoreInfo })

  onResolve = () => {
    const { onResolve, onCancel } = this.props
    onResolve()
    onCancel()
  }

  onReopen = () => {
    const {
      noteId,
      subject,
      urgencyType,
      preferredResponse,
      message,
      onReopen,
      onCancel,
    } = this.props
    const payload = { noteId, subject, urgencyType, preferredResponse, message, noteStatus: 2 }

    onReopen(payload)
    onCancel()
  }

  onCancel = () => {
    const { onCancel } = this.props
    onCancel()
  }

  render() {
    const {
      subject,
      urgencyType,
      preferredResponse,
      message,
      fromUser,
      sentDate,
      status,
    } = this.props
    const { showMoreInfo } = this.state

    const buttons =
      status >= 3
        ? [{ label: 'Reopen', onClick: this.onReopen }, { label: 'Cancel', onClick: this.onCancel }]
        : [
            { label: 'Resolve', onClick: this.onResolve },
            { label: 'Cancel', onClick: this.onCancel },
          ]
    return (
      <FormBody buttons={buttons} style={{ padding: '0 20px' }}>
        <div className={styles.container}>
          <div className={styles.subject}>{`Subject: ${subject}`}</div>
          <Divider />
          <div className={styles.infoContainer}>
            <div className={styles.infoText}>{`From: ${fromUser}`}</div>
            <div className={styles.infoText}>{`Sent: ${moment(sentDate).format(
              'MMM do YYYY, hh:mm'
            )}`}</div>
            <div
              onClick={this.onToggleShowMore}
              style={{ fontSize: 14.5, color: 'rgba(255,2555,255,0.15)', cursor: 'pointer' }}
            >
              {showMoreInfo ? 'Hide Details' : 'Show Details'}
            </div>
            {showMoreInfo && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <div className={styles.infoText}>{`Urgency: ${urgencyType}`}</div>
                <div className={styles.infoText}>{`Preferred Response: ${preferredResponse}`}</div>
                <div className={styles.infoText}>{`Status ${NOTE_STATUS[status]}`}</div>
              </div>
            )}
          </div>
          <Divider />
          <div className={styles.message}>{message}</div>
        </div>
      </FormBody>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/collaborate/queue-panel/note-details/index.js